export default "__VITE_ASSET__dcb422bb__"